// src/pages/AboutUs.js
import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div>
      <Navigation />
      
      <div className="container" style={{ padding: '80px 0' }}>
        <div className="section-header">
          <div className="feature-badge">Our Story</div>
          <h2>About Synked</h2>
        </div>
        
        <div style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
          <p style={{ fontSize: '18px', marginBottom: '30px' }}>
            Synked was founded with a simple but powerful mission: to bridge the gap between talented students 
            seeking real-world experience and companies looking for fresh perspectives and innovative solutions.
          </p>
          
          <h3 style={{ marginBottom: '20px', color: 'var(--primary)' }}>Our Mission</h3>
          <p style={{ marginBottom: '30px' }}>
            We're dedicated to creating a seamless platform that connects talented students with companies 
            for impactful project experiences that benefit everyone. We believe that meaningful project work 
            during education creates better-prepared professionals and helps companies discover exceptional talent.
          </p>
          
          <h3 style={{ marginBottom: '20px', color: 'var(--primary)' }}>Our Vision</h3>
          <p style={{ marginBottom: '30px' }}>
            We envision a world where every student has access to valuable, real-world experience before graduation, 
            and where companies of all sizes can easily tap into the creativity and fresh perspectives that students offer. 
            By facilitating these connections, we're working to transform education-to-career pathways.
          </p>
          
          <h3 style={{ marginBottom: '20px', color: 'var(--primary)' }}>Our Values</h3>
          <div style={{ marginBottom: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div style={{ 
                minWidth: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: 'rgba(108, 99, 255, 0.1)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'var(--primary)',
                fontSize: '24px',
                marginRight: '20px'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M23 4v6h-6"/>
                  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                </svg>
              </div>
              <div>
                <h4 style={{ marginBottom: '10px' }}>Mutual Benefit</h4>
                <p>We create opportunities that genuinely benefit both students and companies, ensuring value flows in both directions.</p>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div style={{ 
                minWidth: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: 'rgba(108, 99, 255, 0.1)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'var(--primary)',
                fontSize: '24px',
                marginRight: '20px'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div>
                <h4 style={{ marginBottom: '10px' }}>Growth Mindset</h4>
                <p>We believe in continuous learning and improvement, for our users and ourselves.</p>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
              <div style={{ 
                minWidth: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: 'rgba(108, 99, 255, 0.1)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'var(--primary)',
                fontSize: '24px',
                marginRight: '20px'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div>
                <h4 style={{ marginBottom: '10px' }}>Inclusivity</h4>
                <p>We're committed to creating opportunities for students from all backgrounds and connecting them with diverse companies.</p>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <div style={{ 
                minWidth: '60px', 
                height: '60px', 
                borderRadius: '50%', 
                backgroundColor: 'rgba(108, 99, 255, 0.1)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'var(--primary)',
                fontSize: '24px',
                marginRight: '20px'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="5"/>
                  <line x1="12" y1="1" x2="12" y2="3"/>
                  <line x1="12" y1="21" x2="12" y2="23"/>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                  <line x1="1" y1="12" x2="3" y2="12"/>
                  <line x1="21" y1="12" x2="23" y2="12"/>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                </svg>
              </div>
              <div>
                <h4 style={{ marginBottom: '10px' }}>Innovation</h4>
                <p>We encourage creative problem-solving and fresh perspectives in all the projects we facilitate.</p>
              </div>
            </div>
          </div>
          
          <h3 style={{ marginBottom: '20px', color: 'var(--primary)' }}>Our Team</h3>
          <p style={{ marginBottom: '20px' }}>
            We're a team of educators, industry professionals, and technologists who are passionate about creating 
            meaningful connections between education and industry. Our diverse backgrounds and experiences inform 
            our approach to building a platform that truly serves the needs of both students and companies.
          </p>
          
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{ marginBottom: '20px' }}>Ready to get started?</h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
              <Link to="/register" className="btn btn-primary">Sign Up Free</Link>
              <Link to="/projects" className="btn btn-outline">Browse Projects</Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutUs;